module.exports = __webpack_public_path__ + "img/f84ff8898c3a4a94b1b30abf3a0583f3.2ea5b6ee.png";